export const OktaClientId = '0oa15aymctiioGwei697'
export const ENV = 'littleelm135' as string
export const OVERSIGHT_ENV_NAME = 'oversight'
export const GCS_ENV_NAME = 'littleelm135'
export const SUBDOMAIN_SUFFIX = 'gcs'
